<template>
  <div class="dropdown dropdown-affiliation-action">
    <button class="btn-outline btn btn-xs btn-info dropdown-toggle" :id="'dropdownMenu-'+affiliation.organisationID" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
      <i class="pe-7s-more pe-1x fa-rotate-90"></i>
    </button>
    <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu1" style="float: right" >
      <template v-if="document.biblio !== true">
        <li><a role="button" @click="dropDownClick('addDocumentToBiblio', document, $event)"><i class="fa fa-plus text-success"></i> Save to Biblio</a></li>
      </template>
      <li><a role="button" @click="dropDownClick('shareDocument', document, $event)"><i class="fa fa-share-alt text-success"></i> Share</a></li>
      <li><a role="button" @click="dropDownClick('citeDocument', document, $event)"><i class="fa fa-quote-right text-success"></i> Cite</a></li>
    </ul>
  </div>
</template>

<style scoped>
  .dropdown-suggestion > ul > li i{
    color: #ffc107;
    font-weight: bold;
  }

  .dropdown-suggestion > ul > li a{
    font-size: 12px;
  }

  .dropdown-suggestion > ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

</style>
<script>

export default {
  components: {},
  props: ['value', 'context', 'document'],
  name: 'DropdownAffiliation',
  data () {
    return {
      affiliation: null
    }
  },
  watch: {
    value: function (value) {
      this.affiliation = value
    },
    affiliation: function (val) {
      this.$emit('input', this.affiliation)
    }
  },
  methods: {
    dropDownClick: function (action, document, event) {
      switch (action) {
        case 'addDocumentToBiblio':
          this.context.addDocumentToBiblio(document)
          break
        case 'shareDocument':
          this.context.shareDocument(document)
          break
        case 'citeDocument':
          this.context.citeDocument(document)
          break
      }

      $('#dropdownMenu-' + this.affiliation.organisationID).dropdown('toggle')

      event.stopPropagation()
    }
  },
  beforeMount () {
    this.affiliation = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DropdownAffiliation.vue